// F6-12: separa los eventos de Sentry por app (App/Panel Admin) y por
// ambiente (Dev/Producción). `import.meta.env.MODE` por sí solo no alcanza:
// depende de qué build command tenga configurado cada proyecto de Vercel, y
// hoy los 4 proyectos (mestly, mestly-dev, mestly-admin-panel,
// mestly-admin-panel-dev) usan el mismo `vite build`, por lo que `MODE`
// resultaría "production" en los 4 — mezclando Dev y Producción en un mismo
// tag de Sentry si se activara sin corregir esto (R-24).
//
// `VITE_APP_ENV` es una variable nueva, a configurar explícitamente en cada
// proyecto de Vercel (mismo patrón ya usado para `APP_BASE_URL` en F5-12):
// "production" en mestly/mestly-admin-panel, "development" en
// mestly-dev/mestly-admin-panel-dev. Si todavía no está configurada, cae de
// vuelta a `MODE` para no romper nada mientras se activa.
export function resolveSentryEnvironment(appName: 'app' | 'admin'): string {
  const appEnv = import.meta.env.VITE_APP_ENV?.trim();
  return `${appName}-${appEnv || import.meta.env.MODE}`;
}
